import type { Step } from '@/components/wizard/Step';

import {
  ConnectMongoAtlasSourceOrganization,
  type MongoAtlasConnectOrganizationState,
} from './connectMongoAtlasSourceOrganization';
import {
  ConnectMongoAtlasSourceProject,
  type MongoAtlasConnectProjectState,
} from './connectMongoAtlasSourceProject';

export const mongoAtlasConnectSourceOrganizationFlow: Step<MongoAtlasConnectOrganizationState> =
  {
    id: 'connect_mongo_atlas_source_organization',
    Component: ConnectMongoAtlasSourceOrganization,
    nonReturnable: false,
  };

export const mongoAtlasConnectSourceProjectFlow: Step<MongoAtlasConnectProjectState> =
  {
    id: 'connect_mongo_atlas_source_project',
    Component: ConnectMongoAtlasSourceProject,
    nonReturnable: false,
  };
